import Swiper from 'swiper';

let swiperClient = {
    init() {

        var swiper = new Swiper('.swiper-container.swiper-client', {
            slidesPerView: 7,
            watchSlidesVisibility: true,
            slidesPerGroup:7,
            spaceBetween: 30,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                // when window width is <= 700px
                700: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                  slidesPerGroup:3,
                },
            },
        });

    }
}

export default swiperClient;
